<template>
	<div class="ReCheckListFields">
		<div v-for="(row, index) in bufferValue" :key="index">
			<div class="field">
				<base-checkbox  class="label mr-2" v-model="row.required" >Обязательное</base-checkbox>           
				<div class="d-flex w-100">
					<ReCheckListField
						class="select"
						v-model="row.field"
						:options="options"
					/>
					<base-button type="primary" class="no-border my-0" simple icon @click="pSettingsRow(index)"><i :class="['d-inline-block', 'tim-icons', row.settings?'icon-minimal-down':'icon-minimal-right']"></i></base-button>
					<base-button type="danger" class="no-border my-0" simple icon @click="pRemoveRow(index)"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
				</div>
			</div>
			<div v-if="row.settings" class="add-field mt-2">
				<div class="row mx-0 mb-2">
					<label class="col-form-label col-md-3" >Лейбл поля</label>
					<input class="col-md-9 form-control" type="text" placeholder="Введите название" v-model.lazy="row.label">
				</div>
				<div class="row mx-0 mb-2">
					<label class="col-form-label col-md-3" >Подпись внутри поля</label>
					<input class="col-md-9 form-control" type="text" placeholder="Введите подпись" v-model.lazy="row.placeholder">
				</div>
			</div>
		</div>
        <div class="buttons">
			<base-button @click="pClickAdd()" class="mx-auto" type="success" simple>Добавить</base-button>
			<base-button @click="pClickDescription()" class="mx-auto" type="info" simple>Документация</base-button>
			<base-button @click="pClickDownload()" class="mx-auto" type="info" simple>Скачать</base-button>
			<base-button @click="pClickUpload()" class="mx-auto" type="info" simple>Загрузить</base-button>
		</div>
	</div>
</template>

<script>
	import { Select, Option } from 'element-ui';
    import ReCheckListField from 'src/our_components/ReCheckListField.vue';
	export default {
		name: 'ReCheckListFields',
		components: {
            ReCheckListField,
			[Option.name]: Option,
			[Select.name]: Select,
		},
		props: {
			counter: String,
			value: {
                type: String,
                default(){return '[]';},
            },
			options:{ 
				type: Array,
				default: function(){return [];},
			},
		},
		data () {
			return {
				ver: 1,
				bufferValue: [],
			}
		},
		watch:{
			value(val){
                this.pFillBuffer();
			},
			bufferValue:{
				deep:true,
				handler(val){
					this.bufferValue = val;
					this.$emit("input", JSON.stringify(this.bufferValue));
				}
			},
		},
		computed: {

		},
		methods: {
            pRemoveRow(id){
                this.bufferValue.splice(id,1);
            },
            pSettingsRow(id){
                this.$set(this.bufferValue[id], 'settings', !this.bufferValue[id].settings);
            },
            pFillBuffer(){
                try{
				    //this.bufferValue = this.$GVO.unlinkObject(val);
                    this.bufferValue = JSON.parse(this.value||'[]');
                }catch(e){
                    this.bufferValue = [];
                }
            },
            pClickAdd(){
                this.bufferValue.push({
                    required: true
                });
            },
            pClickDescription(){
				this.$GVO.ApiCall('CHECKLIST_CONFIGURE.GET_description',{flt:{
					fields: this.bufferValue
				}}).then(apiData=>{
					if(apiData.success){
						
						this.$GVO.showAlert('Документация',`<pre>${apiData.data.replace(/</g,'&lt;')}</pre>`);
						navigator.clipboard.writeText(apiData.data);
					}
				}).catch(e=>alert(e));
                //alert(JSON.stringify(this.bufferValue))
            },
			pClickDownload(){
				let txt = JSON.stringify(this.bufferValue);
				// console.log(txt);
				this.$GVO.showAlert('Список полей',`<pre>${txt.replace(/</g,'&lt;')}</pre>`);
				navigator.clipboard.writeText(txt);
			},
			pClickUpload(){
				this.$GVO.showPrompt('Загрузите поля','список полей').then(result=>{
					if(result.value){
						let fields = JSON.parse(result.value);
						if(fields){
							this.bufferValue=fields
						}else{
							this.$GVO.showAlert('Ошибка',`Не удалось прочитать список полей из переданнйо строки`);
						}
					}
				})
			}
		},
        mounted(){
            this.pFillBuffer();
        }
	}
</script>
<style scoped lang="scss">
.field{
    display:flex;
	flex-wrap: wrap;
    .select{
        flex-grow: 1;
    }
    .label{
        flex-shrink: 0;
    }
}
.add-field{
	// padding-left:1.9em;
}
.buttons{
	display:flex;
	justify-content: space-between;

}
</style>
